module.exports = __webpack_public_path__ + "img/order.de4f0458.svg";